























import { Component, Vue, Watch } from 'vue-property-decorator'
import { convertText } from './processing'

@Component
export default class Home extends Vue {
	inputString: string = `Cats are similar in anatomy to the other felids, with a strong flexible body, quick reflexes, sharp retractable claws and teeth adapted to killing small prey. Cat senses fit a crepuscular and predatory ecological niche. Cats can hear sounds too faint or too high in frequency for human ears, such as those made by mice and other small animals. They can see in near darkness.`
	outputString: string = ''

	mounted () {
    this.convert()
  }

	async convert() {
		this.outputString = 'converting...'
		this.outputString = await convertText(this.inputString)
	}
}
